
export function calculateCutOffTime(hours, minutes){
  let sameDayCutOffHours = 18 - hours; /* Warehouse cut off time 6 PM */
  let sameDayCutOffMinutes = 60 - minutes;
  if(sameDayCutOffMinutes == 60){
    sameDayCutOffMinutes = 0;
  }else{
    sameDayCutOffHours = sameDayCutOffHours - 1;
  }
  let cutOffTime = "";
  if(sameDayCutOffMinutes < 10){
    sameDayCutOffMinutes = "0"+sameDayCutOffMinutes;
  }
  if(sameDayCutOffHours < 12){
    if(sameDayCutOffHours == 0) sameDayCutOffHours = 12;
    cutOffTime = sameDayCutOffHours + ":" + sameDayCutOffMinutes + " AM ET";
  }else{
    sameDayCutOffHours = sameDayCutOffHours % 12;
    if(sameDayCutOffHours == 0) sameDayCutOffHours = 12;
    cutOffTime = sameDayCutOffHours + ":" + sameDayCutOffMinutes + " PM ET";
  }
  return cutOffTime;
}




// WEBPACK FOOTER //
// ./src/pages/orderConfiguration/utilities.js